import MiniLink from 'atoms/mini-link-button';
import PropTypes from 'prop-types';
import React from 'react';
import { translatable } from 'services/Intl';


function TextSection({ level, className, text, id, title, href }) {
  const Heading = `h${level}`;
  return (
    <div className={ `landing-page__text-section ${className} ${text ? '' : '-not-description'}` } id={ id } name={ id }>
      <div className="landing-page__text-section__container">
        { title
          ? (
            <div className="landing-page__text-section__title-section">
              <Heading
                className="landing-page__text-section__title-section__title"
                dangerouslySetInnerHTML={ { __html: title } }
              />
            </div>
          ) : null
        }
        <p className="landing-page__text-section__text" dangerouslySetInnerHTML={ { __html: text } } />
        { href
          ? <MiniLink child="landingpage.miniLink" className="landing-page__text-section__mini-link" href={ href } />
          : null }
      </div>
    </div>
  );
}

TextSection.defaultProps = {
  className: '',
  href: '',
  id: null,
  level: 2,
  text: '',
  title: '',
};

TextSection.propTypes = {
  className: PropTypes.string,
  href: PropTypes.string,
  id: PropTypes.string,
  level: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  text: PropTypes.string,
  title: PropTypes.string,
};

export default translatable(TextSection);
